import { createAction } from '@reduxjs/toolkit';
import { UserRoles } from '../../types/IUser';

export const changeUserRole = createAction<UserRoles>('CHANGE_ROLE');

export const clearUserData = createAction('CLEAR_USER_DATA');
